import { useCallback, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { ReactComponent as CloseBtn } from "../../../assets/icons/Icon.svg";
import { Box } from "@mui/material";
import { CONTRACT_MODAL_ACTION_TYPE } from "../../../redux/actions-type";
import { useFormik } from "formik";
import { ValidationSchema } from "./components/ValidationSchema";
import SubmitBtn from "./components/SubmitBtn";
import InputField from "./components/InputField";
import ContractTypes from "./components/Payments/ContractTypes";
import Status from "./components/Status";

export const ContractModal = () => {
  const [selectedFile, setSelectedFile] = useState(null);
  const dispatch = useDispatch();
  const { contractModalData: modalData } = useSelector(
    (state) => state.contractModal,
  );

  // formik
  const formik = useFormik({
    initialValues: {
      name: modalData?.name ? modalData?.name : "",
      contractType: modalData?.contractType ? modalData?.contractType : "",
    },
    validationSchema: ValidationSchema,
  });
  const setInputValue = useCallback(
    (key, value) =>
      formik.setValues({
        ...formik.values,
        [key]: value,
      }),
    [formik],
  );

  const closeModal = () => {
    dispatch({
      type: CONTRACT_MODAL_ACTION_TYPE.GET_CONTRACT_MODAL,
      payload: { data: {}, openModal: false },
    });
  };

  return (
    <div className="create-update-modal-con">
      <div className="create-update-modal">
        <div className="create-update-modal-head">
          <h2>{modalData?._id ? "Müqaviləni yenilə" : "Müqavilə yaradın"}</h2>
          <CloseBtn onClick={closeModal} />
        </div>
        <Box
          onSubmit={(e) => e.preventDefault()}
          component="form"
          sx={{
            maxWidth: "100%",
            display: "flex",
            justifyContent: "center",
            marginBottom: "50px",
          }}
        >
          <div className="create-update-modal-form">
            <InputField
              setInputValue={setInputValue}
              modalData={modalData}
              formik={formik}
              inputName={"name"}
            />

            <ContractTypes modalData={modalData} formik={formik} />

            <div style={{ marginTop: "20px" }}>
              <input
                type="file"
                accept=".doc,.docx"
                onChange={(e) => setSelectedFile(e.target.files[0])}
              />

              {modalData?.fileName && !selectedFile && (
                <p style={{ fontSize: 12, color: "#888" }}>
                  📄 Mövcud fayl: {modalData.fileName}
                </p>
              )}
              {selectedFile && (
                <p style={{ fontSize: 12, color: "#4caf50" }}>
                  ✅ {selectedFile.name}
                </p>
              )}
            </div>
          </div>
        </Box>

        {modalData?._id ? (
          <div className="create-update-modal-btn-con">
            <Status modalData={modalData} />
            <SubmitBtn
              formik={formik}
              modalData={modalData}
              selectedFile={selectedFile}
              funcType={modalData?._id ? "update" : "create"}
            />
          </div>
        ) : (
          <SubmitBtn
            formik={formik}
            modalData={modalData}
            selectedFile={selectedFile}
            funcType={modalData?._id ? "update" : "create"}
          />
        )}
      </div>
    </div>
  );
};
